import instance from '../axios.config';
import { handleError } from '../../utils';

const transformAccountStatementData = (data) => {
  if (!data || !data.entries) {
    return data;
  }

  const entries = data.entries || [];
  const transactions = entries.filter(
    (entry) =>
      (entry.transaction_type || '').toLowerCase() === 'debit'
  );
  const funding = entries.filter(
    (entry) =>
      (entry.transaction_type || '').toLowerCase() === 'credit'
  );

  const summary = {
    total_transactions: transactions.length,
    successful_transactions: transactions.filter(
      (t) => t.status === 'successful'
    ).length,
    failed_transactions: transactions.filter((t) => t.status === 'failed')
      .length,
    pending_transactions: transactions.filter((t) => t.status === 'pending')
      .length,
    total_amount: transactions.reduce((sum, t) => sum + (t.amount || 0), 0),
    total_debit: transactions.reduce((sum, t) => sum + (t.debit_amount || 0), 0),
    airtime_total: transactions
      .filter((t) => t.product_type === 'airtime')
      .reduce((sum, t) => sum + (t.amount || 0), 0),
    data_total: transactions
      .filter((t) => t.product_type === 'data')
      .reduce((sum, t) => sum + (t.amount || 0), 0),
    total_funding: funding.reduce((sum, f) => sum + (f.amount || 0), 0),
    total_funding_transactions: funding.length,
  };

  return {
    ...data,
    transactions,
    funding,
    summary,
  };
};

const getAccountStatement = async (
  key,
  startDate = null,
  endDate = null,
  page = 1,
  limit = 50
) => {
  try {
    const params = new URLSearchParams();

    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    params.append('page', page);
    params.append('limit', limit);
    params.append('includeTotalCount', 'true');

    const url = `/merchant/account-statement?${params.toString()}`;

    const response = await instance.get(url);
    const rawData = response.data.data;

    return transformAccountStatementData(rawData);
  } catch (error) {
    handleError(error);
  }
};

export { getAccountStatement };
